import { NgModule } from '@angular/core';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import * as brands from '@fortawesome/free-brands-svg-icons';
import * as duotone from '@fortawesome/pro-duotone-svg-icons';
import * as light from '@fortawesome/pro-light-svg-icons';
import * as regular from '@fortawesome/pro-regular-svg-icons';
import * as solid from '@fortawesome/pro-solid-svg-icons';

@NgModule({
  imports: [FontAwesomeModule],
  exports: [FontAwesomeModule],
})
export class FaIconModule {
  constructor(library: FaIconLibrary) {
    library.addIcons(
      solid.faUnlock,
      solid.faFile,
      solid.faEnvelopeOpen,
      solid.faPhone,
      solid.faEnvelope,
      solid.faEye,
      solid.faEyeSlash,
      solid.faUser,
      solid.faCog,
      solid.faCogs,
      solid.faBriefcase,
      solid.faBuilding,
      solid.faPowerOff,
      solid.faLock,
      solid.faLockAlt,
      solid.faShippingFast,
      solid.faPercent,
      solid.faDollarSign,
      solid.faMobile,
      solid.faMobileAlt,
      solid.faAddressCard,
      solid.faSuitcase,
      solid.faLaptop,
      solid.faUsers,
      solid.faSortDown,
      solid.faAngleLeft,
      solid.faPause,
      solid.faPauseCircle,
      solid.faPencil,
      solid.faPen,
      solid.faUserCircle,
      solid.faBars,
      solid.faHome,
      solid.faChevronDown,
      solid.faChevronRight,
      solid.faChevronLeft,
      solid.faAngleDoubleRight,
      solid.faPlusCircle,
      solid.faTimesCircle,
      solid.faAngleRight,
      solid.faCreditCard,
      solid.faExclamation,
      solid.faExclamationCircle,
      solid.faExclamationTriangle,
      solid.faComment,
      solid.faCommentDots,
      solid.faCheck,
      solid.faCheckCircle,
      solid.faComments,
      solid.faPlus,
      solid.faSearch,
      solid.faCaretLeft,
      solid.faCaretRight,
      solid.faCaretDown,
      solid.faTachometer,
      solid.faPaste,
      solid.faLifeRing,
      solid.faQuestion,
      solid.faQuestionCircle,
      solid.faAngleRight,
      solid.faMapMarker,
      solid.faMapMarkerAlt,
      solid.faCircle,
      solid.faWrench,
      solid.faFileImage,
      solid.faCamera,
      solid.faCloudUpload,
      solid.faShieldCheck,
      solid.faLink,
      solid.faUnlink,
      solid.faUpload,
      solid.faEllipsisH,
      solid.faClock,
      solid.faDotCircle,
      solid.faChevronCircleDown,
      solid.faChevronUp,
      solid.faStopwatch,
      solid.faStar,
      solid.faTrash,
      solid.faFileMedicalAlt,
      solid.faIdBadge,
      solid.faIdCardAlt,
      solid.faMap,
      solid.faEdit,
      solid.faFire,
      solid.faThermometerQuarter,
      solid.faThermometerFull,
      solid.faHandsUsd,
      solid.faHandHoldingUsd,
      solid.faStickyNote,
      solid.faGlobe,
      solid.faToolbox,
      solid.faMoneyCheck,
      solid.faMoneyBillWave,
      solid.faBoxUsd,
      solid.faHandshake,
      solid.faFileEdit,
      solid.faFileAlt,
      solid.faBook,
      solid.faBookOpen,
      solid.faBoxCheck,
      solid.faListUl,
      solid.faUsdCircle,
      solid.faCommentAlt,
      solid.faBan,
      solid.faTimes,
      solid.faPenAlt,
      solid.faPrint,
      solid.faUserFriends,
      solid.faEllipsisV,
      solid.faBalanceScaleRight,
      solid.faSignIn,
      solid.faCopyright,
      solid.faSignOutAlt,
      solid.faMailBulk,
      solid.faInfoCircle,
      solid.faSignOut,
      solid.faFolder,
      solid.faFolderOpen,
      solid.faEnvelope,
      solid.faDownload,
      solid.faUndo,
      solid.faChartBar,
      solid.faTable,
      solid.faCalculator,
      solid.faFilter,
      solid.faBookReader,
      solid.faGlobeAmericas,
      solid.faFileSignature,
      solid.faFileUpload,
      solid.faInfo,
      solid.faSave,
      solid.faRedo,
      solid.faColumns,
      solid.faCaretUp,
      solid.faCaretDown,
      solid.faTimes,
      solid.faCalendarDay,
      solid.faHeadset,
      solid.faHammer,
      solid.faPaperPlane,
      solid.faWindowMinimize,
      solid.faWindowMaximize,
      solid.faVideo,
      solid.faExpand,
      solid.faStop,
      solid.faPlay,
      solid.faPause,
      solid.faStop,
      solid.faVolumeUp,
      solid.faVolumeDown,
      solid.faVolumeOff,
      solid.faVolumeMute,
      solid.faVolumeMute,
      solid.faSpinner,
      solid.faSpinnerThird,
      solid.faSpinnerThird,
      // All "regular" style imports go here
      regular.faFile,
      regular.faCheckCircle,
      regular.faPlus,
      regular.faTimes,
      regular.faTimesCircle,
      regular.faTrash,
      regular.faCircle,
      regular.faCheck,
      regular.faDollarSign,
      regular.faExclamationCircle,
      regular.faExclamationTriangle,
      regular.faHome,
      regular.faPhone,
      regular.faEnvelope,
      regular.faIdCardAlt,
      regular.faBirthdayCake,
      regular.faComment,
      regular.faBan,
      regular.faLocationArrow,
      regular.faFileAlt,
      regular.faCopyright,
      regular.faExternalLink,
      regular.faLongArrowLeft,
      regular.faMinus,
      regular.faPencil,
      regular.faArrowAltCircleRight,
      regular.faArrowCircleRight,
      regular.faCalendarDay,
      regular.faAngleRight,
      regular.faStar,
      regular.faHammer,
      regular.faPaperPlane,
      regular.faWindowMinimize,
      regular.faWindowMaximize,
      // All "light" style imports go here
      light.faFile,
      light.faFilePdf,
      light.faLongArrowRight,
      light.faLongArrowLeft,
      light.faPlusCircle,
      light.faPlus,
      light.faSpinnerThird,
      light.faSpinner,
      light.faTimes,
      light.faGreaterThan,
      light.faGreaterThanEqual,
      light.faLessThan,
      light.faLessThanEqual,
      light.faEquals,
      light.faHammer,
      light.faPaperPlane,
      light.faWindowMinimize,
      light.faWindowMaximize,
      // All "brands" style imports go here
      brands.faGoogle,
      brands.faFacebookF,
      brands.faFacebook,
      brands.faLinkedin,
      brands.faTwitterSquare,

      // Duotone imports go here.
      duotone.faCheckCircle,
      duotone.faChevronSquareDown,
      duotone.faChevronSquareUp,
      duotone.faCircle,
      duotone.faCopy,
      duotone.faPrint,
      duotone.faPlusCircle,
      duotone.faPencil,
      duotone.faExclamationCircle,
      duotone.faFileUpload,
      duotone.faChevronCircleRight,
      duotone.faPaperPlane,
      duotone.faWindowMinimize,
      duotone.faWindowMaximize
    );
  }
}
